import module from '../module';
import Constants from '../../../utils/CommonConstants';


LoginTicketController.$inject = [ 'Session', 'LocalForageService', 'CartService',
    '$state', '$stateParams', 'AuthenticationService', 'Message', 'UserProfile',
    'cartonomyConfig', '$rootScope' ];

export async function LoginTicketController(sessionService, localForageService, cartService,
                                            $state, $stateParams, authenticationService, messageService, userProfileService,
                                            cartonomyConfig, $rootScope) {
    // check if window is inside frame if this is shopify
    if (cartonomyConfig.externalStoreMode) {
        let isInIframe = window.self !== window.top;

        if (!isInIframe) {
            // do nothing
            return;
        }
    }

    const authToken = $stateParams.authToken;

    if (!authToken && $stateParams.errorMessage) {
        await messageService.showErrorPopup($stateParams.errorMessage);

        if (!(await sessionService.loggedIn())) {
            await authenticationService.showLoginDialog();
        }
        await checkCartAndGo();
        return;
    }

    await authenticationService.waitForLogin();

    try {
        await authenticationService.externalLoginFinalize(authToken);
    } catch (error) {
        await messageService.showErrorPopupForResponse(error);
        $state.go(Constants.RoutingStates.CATALOG);
        return;
    }
    await cartService.clearLocalCart();

    await sessionService.clearSessionDetails();
    await sessionService.setSessionDetails({
        authToken: authToken,
        userEmail: await sessionService.getUserEmail(),
        userName: await sessionService.getUserName()
    });

    userProfileService.resetUser();
    const user = await userProfileService.getUser();

    await sessionService.setSessionDetails({
        authToken: authToken,
        userEmail: user.email,
        userName: user.fullName,
        firstName: user.firstName,
        lastName: user.lastName
    });

    let awaitingInvitation = await localForageService.retrieve(Constants.SessionStorage.AwaitingInvitation);
    if (awaitingInvitation) {
        $state.go(Constants.RoutingStates.INVITE, JSON.parse(awaitingInvitation));
        return;
    }

    let linkingSocialAccount = await localForageService.retrieve(Constants.SessionStorage.LINKING_SOCIAL_ACCOUNT);
    if (linkingSocialAccount) {
        await localForageService.remove(Constants.SessionStorage.LINKING_SOCIAL_ACCOUNT);
        $state.go(Constants.RoutingStates.USER_PROFILE);
        return;
    }

    sessionService.setCartReference(null);
    await checkCartAndGo();

    async function checkCartAndGo() {
        let cartExists = await cartService.isGroupOrder();
        let stateToGo = cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CHAT : Constants.RoutingStates.CATALOG;
        if (!cartExists && cartonomyConfig.externalStoreMode) {
            stateToGo = Constants.RoutingStates.CART;
        }
        $rootScope.$broadcast(Constants.Events.USER_LOGGED_IN);
        $state.go(stateToGo);
    }
}

module.controller('Cartonomy.Shared.LoginTicketController', LoginTicketController);



// WEBPACK FOOTER //
// ./src/modules/shared/controllers/LoginTicketController.js